import React from "react";
import { cn } from "../../../lib/utils";
import { useConfiguratorContext } from "@studio3dx/legacy-use-configurator/react";
import { SelectionIndicator } from "./SelectionIndicator";
import { OptionInfo } from "./OptionInfo";
import { OptionThumbnail } from "./OptionThumbnail";
import { OptionPrice } from "./OptionPrice";
import { ConflictIndicator } from "./ConflictIndicator";

interface DefaultDisplayProps {
  options: any[];
  section: any;
}

export const DefaultDisplay: React.FC<DefaultDisplayProps> = ({
  options,
  section,
}) => {
  const configurator = useConfiguratorContext();
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
      {options.map((option) => (
        <div
          key={option.id}
          className={cn(
            "cursor-pointer flex flex-col gap-3 transition-all duration-200",
            section?.metadata?.uiTileBasis,
            !configurator.canSelectOption(section.id, option.id) &&
              "opacity-50 relative"
          )}
          title={
            !configurator.canSelectOption(section.id, option.id)
              ? "Selecting this option will replace incompatible selections"
              : ""
          }
        >
          <div
            onClick={() => configurator.toggleOption(section.id, option.id)}
            className={cn(
              "w-full aspect-square overflow-hidden relative hover:shadow-lg transition-all duration-500 border group",
              configurator.isOptionSelected(option.id)
                ? "border-black shadow-lg"
                : "border-gray-200 hover:border-black"
            )}
            style={{
              backgroundColor: option?.metadata?.uiColor,
            }}
          >
            <OptionThumbnail
              option={option}
              width={250}
              height={250}
              className="object-center object-contain h-full w-full"
            />
            <OptionInfo option={option} />
            {configurator.isOptionSelected(option.id) && (
              <div className="absolute top-2 right-2 bg-black text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold">
                ✓
              </div>
            )}
            <ConflictIndicator
              hasConflict={!configurator.canSelectOption(section.id, option.id)}
            />
          </div>
          <div className="flex flex-col gap-2 mt-4">
            <p
              className={cn(
                "text-base text-ellipsis",
                configurator.isOptionSelected(option.id)
                  ? "text-black"
                  : "text-black"
              )}
              style={{ fontWeight: "300" }}
            >
              {option.label}
            </p>
            <OptionPrice
              price={option.price}
              isSelected={configurator.isOptionSelected(option.id)}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
